import React from 'react';
import { Box, Button, Checkbox, TextField, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Autocomplete } from '@material-ui/lab';
import facultyOptions from '../config/faculty.json';

interface Props {
  countries: Country[];
  faculties: string[];
  countryOptions: Country[];
  onClose: () => void;
  onCountryChange: (value: Country[]) => void;
  onFacultyChange: (value: string[]) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    display: 'block',
    marginLeft: 16,
    minWidth: 130,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  filter: {
    display: 'flex',
    width: '100%',
    '@media (max-width:480px)': {
      flexDirection: 'column',
    },
  },
  filterBox: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'space-between',
    padding: `24px 0px`,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  textField: {
    backgroundColor: '#FFF',
    borderRadius: '4px',
  },
}));

const FilterBox: React.FC<Props> = ({
  countries,
  faculties,
  countryOptions,
  onClose,
  onCountryChange,
  onFacultyChange,
}) => {
  const { button, filter, filterBox, textField } = useStyles();

  return (
    <div className={filterBox}>
      <Box className={filter}>
        <Autocomplete
          fullWidth
          multiple
          disableCloseOnSelect
          value={countries}
          options={countryOptions}
          getOptionLabel={(option) => option.title}
          getOptionSelected={(option, value) => option.title === value.title}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              {option.title}
            </>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              className={textField}
              size="small"
              variant="filled"
              label="Country"
              placeholder={
                countries.length
                  ? countries.map((country) => country.title).join(',')
                  : 'Country'
              }
            />
          )}
          renderTags={() => <></>}
          onChange={(event, value) => onCountryChange(value)}
        />
        <Box width={8} height={8} />
        <Autocomplete
          fullWidth
          multiple
          options={facultyOptions}
          disableCloseOnSelect
          renderOption={(option, { selected }) => (
            <>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              {option}
            </>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              className={textField}
              size="small"
              variant="filled"
              label="Field of Interest"
              placeholder={
                faculties.length ? faculties.join(',') : 'Field of Interest'
              }
            />
          )}
          renderTags={() => <></>}
          onChange={(event, value) => onFacultyChange(value)}
        />
      </Box>
      <Button
        className={button}
        variant="outlined"
        color="secondary"
        onClick={onClose}
      >
        Hide Results
      </Button>
    </div>
  );
};

export default FilterBox;
